import { useMemo } from 'react';
import { FieldErrors } from 'react-hook-form';
import { AddressFormState } from '../types';

export const useErrorProps = (prop: keyof AddressFormState, fieldErrors: FieldErrors<AddressFormState>) =>
    useMemo(
        () => ({
            error: Boolean(fieldErrors[prop]),
            helperText: fieldErrors[prop]?.message || '',
        }),
        [fieldErrors[prop]],
    );
